import { restClient } from './client';
import { Structure } from '../../../models';

export const structureService = {
    get: async () => {
        const response = await restClient.get<Structure>('/structure');
        return response.data;
    },
};
